/* Social proof — UGC videoslider + lightbox (NEW PDP).
   Custom element <social-proof>: pijl-navigatie voor de slider + een lightbox
   die de klantvideo afspeelt (autoplay bij openen, pauze bij sluiten/navigeren),
   met vorige/volgende/sluiten, klik-buiten en Esc. Rendert defensief. */
class SocialProof extends HTMLElement {
  constructor() {
    super();
    this._onKey = this._onKey.bind(this);
    this.index = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('[data-sp-track]');
    this.cards = Array.from(this.querySelectorAll('[data-sp-card]'));
    this.lightbox = this.querySelector('[data-sp-lightbox]');
    this.video = this.querySelector('[data-sp-video]');
    this.placeholder = this.querySelector('[data-sp-ph]');
    this.capText = this.querySelector('[data-sp-cap]');
    this.capName = this.querySelector('[data-sp-name]');

    const prev = this.querySelector('[data-sp-prev]');
    const next = this.querySelector('[data-sp-next]');
    if (prev) prev.addEventListener('click', () => this._scroll(-1));
    if (next) next.addEventListener('click', () => this._scroll(1));

    this.cards.forEach((card, i) => card.addEventListener('click', () => this.open(i)));

    if (this.lightbox) {
      const close = this.querySelector('[data-sp-close]');
      const lbPrev = this.querySelector('[data-sp-lbprev]');
      const lbNext = this.querySelector('[data-sp-lbnext]');
      if (close) close.addEventListener('click', () => this.close());
      if (lbPrev) lbPrev.addEventListener('click', () => this.go(-1));
      if (lbNext) lbNext.addEventListener('click', () => this.go(1));
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.close();
      });
    }
  }

  _scroll(dir) {
    if (!this.track) return;
    const amount = Math.max(300, Math.round(this.track.clientWidth * 0.85));
    this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  open(i) {
    if (!this.lightbox || !this.cards.length) return;
    this.index = i;
    this._populate();
    this.lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKey);
  }

  close() {
    if (!this.lightbox) return;
    this.lightbox.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKey);
    this._stopVideo();
  }

  go(dir) {
    const n = this.cards.length;
    if (!n) return;
    this.index = (this.index + dir + n) % n;
    this._populate();
  }

  _stopVideo() {
    if (!this.video) return;
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load();
  }

  _populate() {
    const card = this.cards[this.index];
    if (!card) return;
    const src = card.getAttribute('data-src') || '';

    this._stopVideo();

    if (src && this.video) {
      const poster = card.getAttribute('data-poster') || '';
      if (poster) this.video.poster = poster; else this.video.removeAttribute('poster');
      this.video.src = src;
      this.video.hidden = false;
      if (this.placeholder) this.placeholder.hidden = true;
      const p = this.video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } else {
      if (this.video) this.video.hidden = true;
      if (this.placeholder) this.placeholder.hidden = false;
    }

    if (this.capText) this.capText.textContent = card.getAttribute('data-caption') || '';
    if (this.capName) this.capName.textContent = card.getAttribute('data-name') || '';
  }

  _onKey(e) {
    if (e.key === 'Escape') this.close();
    else if (e.key === 'ArrowLeft') this.go(-1);
    else if (e.key === 'ArrowRight') this.go(1);
  }
}

if (!customElements.get('social-proof')) {
  customElements.define('social-proof', SocialProof);
}
